import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {actions} from './action'
import {actionTypes} from './constants'
import {service} from './service'
import {ShareholderListParams} from '../Model'

function* getShareholderRecordsSaga(action: ActionModel) {
  try {
    // ActionModel.payload is typed as a string map; the list params include numbers (page, limit)
    const params = action.payload as unknown as ShareholderListParams
    yield delay(500)
    const response: ResponseModel = yield call(service.getRecords, params)
    yield put(actions.getShareholderRecordsSuccess(response?.data?.data))
    yield put(actions.getShareholderRecordsFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getShareholderRecordsFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_SHAREHOLDER_RECORDS_START, getShareholderRecordsSaga)
}
